import { HttpClient, HttpParams } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ClientTableRow, TgClient } from '../models/telegram/tg-client.model';
import { PagedResult } from '../models/screen.model';
import { SelectOption } from '../models/SelectOption';

@Injectable({
  providedIn: 'root'
})
export class ClientService {

  constructor(
    private http: HttpClient,
    @Inject('BASE_URL')
    private baseUrl: string
  ) { }

  get(pageNumber: number, pageSize: number): Observable<PagedResult<ClientTableRow>> {
    const params = new HttpParams()
      .set('pageNumber', pageNumber)
      .set('pageSize', pageSize);

    return this.http.get<PagedResult<ClientTableRow>>(`${this.baseUrl}api/clients`, {params});
  }

  getBy(gender: string, region: string, lang: string): Observable<PagedResult<TgClient>> {
    const params = new HttpParams()
      .set('pageNumber', 1)
      .set('pageSize', 5000)
      .set('gender', gender)
      .set('region', region)
      .set('lang', lang);

    return this.http.get<PagedResult<TgClient>>(`${this.baseUrl}api/clients`, { params });
  }

  getSelectOptions(gender: string, region: string, lang: string): Observable<SelectOption[]> {
    const params = new HttpParams()
      .set('pageNumber', 1)
      .set('pageSize', 5000)
      .set('gender', gender)
      .set('region', region)
      .set('lang', lang);

    return this.http.get<SelectOption[]>(`${this.baseUrl}api/clients/options`, { params });
  }

  getById(id: string): Observable<TgClient> {
    return this.http.get<TgClient>(`${this.baseUrl}api/clients/${id}`);
  }

  create(newClient: TgClient): Observable<TgClient> {
    return this.http.post<TgClient>(`${this.baseUrl}api/clients`, newClient);
  }

  update(updatedClient: TgClient): Observable<void> {
    return this.http.put<void>(`${this.baseUrl}api/clients/${updatedClient.id}`, updatedClient);
  }

  delete(id: string): Observable<void> {
    return this.http.delete<void>(`${this.baseUrl}api/clients/${id}`);
  }
}
